import { render, staticRenderFns } from "./ProductBundleOptions.vue?vue&type=template&id=36d90d4e&scoped=true&"
import script from "./ProductBundleOptions.vue?vue&type=script&lang=js&"
export * from "./ProductBundleOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d90d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d90d4e')) {
      api.createRecord('36d90d4e', component.options)
    } else {
      api.reload('36d90d4e', component.options)
    }
    module.hot.accept("./ProductBundleOptions.vue?vue&type=template&id=36d90d4e&scoped=true&", function () {
      api.rerender('36d90d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/ProductBundleOptions.vue"
export default component.exports